//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowReviews",
    props: {
        htmlTag: {
            default: null,
            type: String,
        },
        list: {
            default: () => [],
            type: Array,
        },
    },
    data: () => ({}),
    mounted() {},
};
